import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'reactstrap'
import './LLMAnswerServicesField.css'

const LLMAnswerServicesField = ({
  selected,
  services,
  options,
  error,
  forceWebSearch,
  onChange,
  onSelectionChange,
  onForceWebSearchChange,
}) => {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(services)
  const [draftSelected, setDraftSelected] = useState(selected)
  const [draftForceWebSearch, setDraftForceWebSearch] = useState(forceWebSearch)
  const providers = options?.providers || []
  const active = providers.filter(({ id }) => selected[id])

  const openModal = () => {
    setDraft(services)
    setDraftSelected(selected)
    setDraftForceWebSearch(forceWebSearch)
    setOpen(true)
  }

  const toggleProvider = ({ id, default: defaultMode, modes }) => {
    const nextSelected = !draftSelected[id]
    setDraftSelected({ ...draftSelected, [id]: nextSelected })
    if (nextSelected) {
      const availableModes = modes.filter(
        ({ id: mode }) => mode !== 'anakin' || options?.is_superuser
      )
      if (!availableModes.some(({ id: mode }) => mode === draft[id])) {
        const nextMode =
          availableModes.find(({ id: mode }) => mode === defaultMode) || availableModes[0]
        if (nextMode) setDraft({ ...draft, [id]: nextMode.id })
      }
    }
  }

  return (
    <div className="mt-3">
      {error && <div role="alert">Impossibile caricare i provider LLM.</div>}
      {!options && !error && <div>Caricamento provider LLM...</div>}
      <Button type="button" color="secondary" size="sm" onClick={openModal} disabled={!options}>
        Configure providers
      </Button>
      <div className="mt-2">
        {active.length
          ? active
              .map(
                ({ id, label, modes }) =>
                  `${label}: ${modes.find(({ id: mode }) => mode === services[id])?.label || ''}`
              )
              .join(' · ')
          : 'Nessun provider selezionato'}
        {active.length > 0 && ` · Force web search: ${forceWebSearch ? 'on' : 'off'}`}
      </div>
      <Modal show={open} onHide={() => setOpen(false)} className="llm-providers-modal">
        <Modal.Header closeButton>
          <Modal.Title>Configure providers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="llm-providers-modal__intro">
            Select LLM providers and their execution mode:
          </p>
          {providers.map((provider) => {
            const { id: llm, label, modes } = provider
            return (
              <div key={llm} className="llm-providers-modal__provider">
                <label className="llm-providers-modal__choice">
                  <input
                    type="checkbox"
                    checked={!!draftSelected[llm]}
                    onChange={() => toggleProvider(provider)}
                  />
                  <span>{label}</span>
                </label>
                {draftSelected[llm] && (
                  <div
                    className="llm-providers-modal__modes"
                    role="group"
                    aria-label={`${label} execution mode`}
                  >
                    <div className="llm-providers-modal__mode-options">
                      {modes
                        .filter(({ id: mode }) => mode !== 'anakin' || options?.is_superuser)
                        .map(({ id: mode, label: modeLabel }) => (
                          <label key={mode} className="llm-providers-modal__choice">
                            <input
                              type="radio"
                              name={`answer-mode-${llm}`}
                              value={mode}
                              checked={draft[llm] === mode}
                              onChange={() => setDraft({ ...draft, [llm]: mode })}
                            />
                            <span>{modeLabel}</span>
                          </label>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
          <div className="llm-providers-modal__global">
            <label className="llm-providers-modal__choice">
              <input
                type="checkbox"
                checked={!!draftForceWebSearch}
                onChange={() => setDraftForceWebSearch(!draftForceWebSearch)}
              />
              <span>Force web search for supported providers</span>
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" color="secondary" outline onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            type="button"
            color="primary"
            disabled={!providers.some(({ id }) => draftSelected[id])}
            onClick={() => {
              onSelectionChange(draftSelected)
              onChange(draft)
              onForceWebSearchChange(draftForceWebSearch)
              setOpen(false)
            }}
          >
            Save providers
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default LLMAnswerServicesField
